import { getFileExtension, BulkUploadType, MEDIA_CONFIG } from '../constants/mediaConfig';

export const matchesMediaType = (file: File, mediaType: BulkUploadType): boolean => {
  const extension = getFileExtension(file.name);
  if (MEDIA_CONFIG[mediaType].extensions.includes(extension)) {
    return true;
  }

  switch (mediaType) {
    case 'photo':
      return file.type.startsWith('image/');
    case 'video':
      return file.type.startsWith('video/');
    case 'audio':
      return file.type.startsWith('audio/');
    case 'document':
      return file.type === 'application/pdf';
    default:
      return false;
  }
};

export const isPersistedPreviewUrl = (url?: string | null): url is string => {
  if (!url) return false;
  if (url.startsWith('blob:')) return false;
  return url.startsWith('data:') || url.startsWith('http://') || url.startsWith('https://');
};
